<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="科目代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['subjectCode']" placeholder="请输入科目代码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科目编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['subjectName']" placeholder="请输入科目编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="成本项编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['costCode']" placeholder="请输入成本项编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="成本项描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['costName']" placeholder="请输入成本项描述"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="凭证类型(10：计提 20：冲销 30：正式 40:结转）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['certificateType']" placeholder="请输入凭证类型(10：计提 20：冲销 30：正式 40:结转）"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="费用类型(10：代养费 20：分红）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['feeType']" placeholder="请输入费用类型(10：代养费 20：分红）"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['companyCode']" placeholder="请输入公司"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="服务组" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['groupCode']" placeholder="请输入服务组"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="养殖场编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['farmCode']" placeholder="请输入养殖场编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="养户编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['farmerCode']" placeholder="请输入养户编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.contractNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" placeholder="请输入合同编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.batch')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['breedBatchCode']" placeholder="请输入批次"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="推送状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['status']" placeholder="请输入推送状态"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="生成时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择生成时间" v-decorator="['certificateTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="记录数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['certificateQty']" placeholder="请输入记录数量" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.amount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['certificateAmount']" :placeholder="$t('label.pleaseEnterTheAmount')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="账期编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['accountCode']" placeholder="请输入账期编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="扩展字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer1']" placeholder="请输入扩展字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="扩展字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer2']" placeholder="请输入扩展字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="扩展字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer3']" placeholder="请输入扩展字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="扩展字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer4']" placeholder="请输入扩展字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="扩展字段" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer5']" placeholder="请输入扩展字段"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['validFlag']" :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['delFlag']" placeholder="请输入是否删除"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['notes']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'EfsCapCertificateForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/certificateManage/efsCapCertificate/add",
          edit: "/certificateManage/efsCapCertificate/edit",
          queryById: "/certificateManage/efsCapCertificate/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'subjectCode','subjectName','costCode','costName','certificateType','feeType','companyCode','groupCode','farmCode','farmerCode','conCode','breedBatchCode','status','certificateTime','certificateQty','certificateAmount','accountCode','buffer1','buffer2','buffer3','buffer4','buffer5','validFlag','delFlag','notes'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'subjectCode','subjectName','costCode','costName','certificateType','feeType','companyCode','groupCode','farmCode','farmerCode','conCode','breedBatchCode','status','certificateTime','certificateQty','certificateAmount','accountCode','buffer1','buffer2','buffer3','buffer4','buffer5','validFlag','delFlag','notes'))
      },
    }
  }
</script>